const MobileMenuv2 = [
  {
    title: "Users",
    name: "MobileV2Users",
    icon: "mdi-account-multiple",
  },
  {
    title: "Profiling",
    name: "MobileV2ProfilingQuestion",
    icon: "mdi-account-box",
  },
    {
    title: "Tasks",
    name: "MobileV2Tasks",
    icon: "mdi-clipboard-text",
  },
  {
    title: "Task Status",
    name: "MobileV2TaskStatus",
    icon: "mdi-checkbox-marked-circle-outline",
  },
  {
    title: "Task Notify",
    name: "MobileV2TaskNotify",
    icon: "mdi-bell",
  },
  {
    title: "Push Notification",
    name: "MobileV2PushNotification",
    icon: "mdi-bell",
  },
  {
    title: "Assign Task",
    name: "MobileV2AssignTask",
    icon: "mdi-clipboard-check",
  },
  {
    title: "Project Data",
    name: "MobileV2ProjectData",
    icon: "mdi-database",
  },
  {
    title: "Receipts",
    name: "MobileV2Receipts",
    icon: "mdi-receipt",
  },

  {
    title: "Cashouts",
    name: "MobileV2Cashout",
    icon: "mdi-cash-multiple",
  },
  {
    title: "Rewards",
    name: "MobileV2Rewards",
    icon: "mdi-gift",
  },
  {
    title: "Deals",
    name: "MobileV2Deals",
    icon: "mdi-tag-multiple",
  },

  {
    title: "I Consume",
    name: "MobileV2IConsume",
    icon: "mdi-food-apple",
  },
  {
    title: "Issues",
    name: "MobileV2Issues",
    icon: "mdi-alert-circle",
  },
  {
    title: "Outernet",
    name: "MobileV2Outernet",
    icon: "mdi-trophy-award",
  },
  {
    title: "Audios",
    name: "MobileV2Audios",
    icon: "mdi-music-note",
  },
];
// reorder menu
MobileMenuv2.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default MobileMenuv2;
